"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StreamPlayer = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _constants = require("../../../constants");
var _EmbedPlayer = require("../EmbedPlayer");
var _AmazonIVSPlayer = require("../AmazonIVSPlayer");
var _interactiveStream = require("../../../constants/interactiveStream");
var StreamPlayer = exports.StreamPlayer = function StreamPlayer(_ref) {
  var playbackUrl = _ref.playbackUrl,
    sourceType = _ref.sourceType,
    embedCode = _ref.embedCode,
    height = _ref.height,
    muted = _ref.muted,
    playbackWaitingMessage = _ref.playbackWaitingMessage,
    onPlaybackStarted = _ref.onPlaybackStarted;
  return sourceType === _constants.EMBED_SOURCE_TYPE ? _react["default"].createElement(_EmbedPlayer.EmbedPlayer, {
    embedCode: embedCode
  }) : _react["default"].createElement(_AmazonIVSPlayer.AmazonIVSPlayer, {
    onPlaybackStarted: onPlaybackStarted,
    playbackUrl: playbackUrl,
    height: height,
    muted: muted,
    playbackWaitingMessage: playbackWaitingMessage
  });
};
StreamPlayer.defaultProps = {
  playbackWaitingMessage: 'Waiting for playback...',
  height: 300,
  muted: false
};
StreamPlayer.propTypes = {
  playbackUrl: _propTypes["default"].string,
  sourceType: _interactiveStream.SOURCE_TYPE_PROPS,
  embedCode: _propTypes["default"].string,
  playbackWaitingMessage: _propTypes["default"].string,
  height: _propTypes["default"].number,
  muted: _propTypes["default"].bool,
  onPlaybackStarted: _propTypes["default"].func
};